/**
 * Created by mady on 05-07-2016.
 */

require('../../../retail/shared/wdh-legacy/color-spot/js/base/component-color-selector-spot.js');
(function () {
  window.DGS.ColorSpotConfig.backgroundColorHeight = '75%';
  window.DGS.ColorSpotConfig.backgroundColorOpacity = 0.5;
  window.DGS.ColorSpotConfig.colorBorders['rgb(255, 255, 255)'] = '1px solid #7f7f7f';
})();